import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpinnerService } from 'app/services/spinner.service';
import { RegisterService } from 'app/services/user/register.service';

@Component({
  selector: 'ms-registration-email-confirm',
  templateUrl: './registration-email-confirm.component.html',
  styleUrls: ['./registration-email-confirm.component.css']
})
export class RegistrationEmailConfirmComponent implements OnInit {

  emailVerified: boolean = false;
  message: String;
  showConfirmMsg: Boolean = false;

  constructor(private route: ActivatedRoute,
    private registerService: RegisterService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();
    const activationCode = this.route.snapshot.paramMap.get('activationCode');

    this.registerService.getActivateVerifiedUser(activationCode).subscribe(activeCodeData => {
      if (activeCodeData != null) {
        this.emailVerified = activeCodeData.emailVerified;
        if (this.emailVerified) {
          this.showConfirmMsg = true;
          var timeleft = 10;
          var downloadTimer = setInterval(function () {
            if (timeleft <= 0) {
              clearInterval(downloadTimer);
              this.showConfirmMsg = false;
              window.location.href = '/sso';
            } else {
              document.getElementById("countdown").innerHTML = "puoi accedere in " + timeleft + " secondi";
            }
            timeleft -= 1;
          }, 1000);
        }
      }
    }, err => {
    });
    this.spinnerService.stop();
  }
}
